import { RootState } from "../store";

export const selectCangoGoBack= (state: RootState) => state.payment.canGoBack;
export const selectPaymentData = (state: RootState) => state.payment.paymentFormData;
export const selectPaymentErrorMessage = (state: RootState) => state.payment.errorMessage